import Hero from './components/Hero';
import About from './components/About';
import Programs from './components/Programs';
import News from './components/News';
import Admission from './components/Admission';
import Donation from './components/Donation';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <About />
      <Programs />
      <News />
      <Admission />
      <Donation />
      <Gallery />
      <Contact />
      <Footer />
    </div>
  );
}
